import React, { useEffect, useRef } from "react";

import { scrollIntoViewIfNeeded } from "../lib/scrollIntoView";

import Creatable from "./creatable";

const DropdownItem = (props) => {
    const dropdownItem = useRef();
    useEffect(() => {
        if (props.selected) {
            scrollIntoViewIfNeeded(dropdownItem.current);
        }
    }, [props.selected]);

    const onItemClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        props.onSelect(props.data);
    };
    const cssClass = props.selected ? "dropdown-item -active" : "dropdown-item";

    return (
        <a ref={dropdownItem} href="#typeahead" tabIndex="-1" aria-label={props.text} aria-selected={props.selected} role="option" className={cssClass} onClick={onItemClick}>
            {props.data.text || props.data}
        </a>
    );
};

const Dropdown = React.forwardRef((props, ref) => {
    let showCreatable = props.creatable && props.inputValue && !props.isFetching;
    const list = props.data.map((data, index) => {
        const selected = props.activeIndex === index ? true : false;
        const key = `${props.id}_${data.value || data}`;

        if (showCreatable) {
            if (data.text.toLowerCase() === props.inputValue.toLowerCase()) {
                showCreatable = false;
            }
        }

        return <DropdownItem key={key} index={index} selected={selected} data={data} onSelect={props.onSelect} />;
    });

    return (
        <div id={props.id} className="dropdown-menu" role="listbox" ref={ref}>
            {list}
            {showCreatable && <Creatable value={props.inputValue} provider={props.provider} tags={props.tags} onSelect={props.onSelect} lengthRestriction={props.lengthRestriction} />}
        </div>
    );
});

export default Dropdown;
